import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getTimelineButtons } from './get-frontline-timeline-buttons'
import { getWorkflowButtons } from './get-frontline-workflow-buttons'

export const getFrontlinePendingActionButtons = ({
  canSendComment,
  canSendReminder,
  t,
  sendEvent,
  refetch,
  setMessageDrawerProps,
  task,
  isOffice,
  handleButtonAction,
  setDialogProps,
}: ResolveActionButtonsProps) => {
  const { timeline } = task
  const taskHasTimeline = Boolean(timeline?.length)

  return [
    ...(taskHasTimeline
      ? getTimelineButtons({
          canSendComment,
          canSendReminder,
          t,
          sendEvent,
          refetch,
          setMessageDrawerProps,
          task,
          isOffice,
          handleButtonAction,
          setDialogProps,
        })
      : []),
    ...getWorkflowButtons({
      canSendComment,
      canSendReminder,
      t,
      sendEvent,
      refetch,
      setMessageDrawerProps,
      task,
      isOffice,
      handleButtonAction,
      setDialogProps,
    }),
  ]
}
